
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";

export default BaseCmsBlock.extend({
  name: "ImageBlock",

  computed: {
    isGif: function () {
      const extension = String(this.extras?.image?.source || "").split(".").pop();
      return ['gif'].includes(extension)
    },
    gifUrlPc: function () {
      return [process.env.baseApiUrl, this.extras?.image?.source].join('')
    },
    gifUrlMobile: function () {
      return [process.env.baseApiUrl, this.extras?.imageMobile?.source].join('')
    },

    rootClassName: function () {
      let list = [];
      if (this.cfgs?.alignment) {
        list.push(this.cfgs?.alignment);
      }
      return list.join(' ')
    }
  }
})
